export const technologies = {
  breadcrumb: {
    home: 'Accueil',
    technologies: 'Technologies',
  },
  hero: {
    title: 'Technologies de Filtration',
    subtitle: 'Portefeuille complet de technologies avancées de séparation et de purification pour diverses applications industrielles',
  },
  sections: {
    reverseOsmosis: {
      name: 'Osmose Inverse',
      description: "Processus de filtration membranaire à haute pression qui élimine les solides dissous, les ions et les contaminants de l'eau et des fluides industriels par des membranes semi-perméables.",
      howItWorksTitle: 'Comment Ça Marche',
      howItWorks: [
        "L'eau d'alimentation est pressurisée à 15-70 bar",
        'Les molécules deau passent à travers la membrane semi-perméable',
        'Les solides dissous et contaminants sont rejetés',
        'Le perméat purifié est collecté',
        "Le flux concentré est rejeté ou recyclé",
      ],
      applicationsTitle: 'Applications Industrielles',
      appDesalination: 'Dessalement',
      appDesalinationDesc: "Traitement de l'eau de mer et saumâtre",
      appUltraPureWater: 'Eau Ultra-Pure',
      appUltraPureWaterDesc: 'Industries pharmaceutique et électronique',
      appFoodBeverage: 'Agroalimentaire & Boissons',
      appFoodBeverageDesc: "Eau de processus et concentration d'ingrédients",
      appWastewater: 'Eaux Usées',
      appWastewaterDesc: "Récupération et réutilisation de l'eau",
      advantagesTitle: 'Avantages Clés',
      advantages: [
        "Élimine 95-99% des solides dissous",
        "Produit de l'eau de haute pureté",
        'Empreinte au sol compacte',
        'Opération automatisée',
        'Faible consommation de produits chimiques',
        'Qualité de produit constante',
      ],
      specsTitle: 'Spécifications Techniques',
      specParticleRemoval: "Élimination de Particules",
      specOperatingPressure: 'Pression de Fonctionnement',
      specRejectionRate: 'Taux de Rejet',
      specTempRange: "Plage de Température",
    },
    nanofiltration: {
      name: 'Nanofiltration',
      description: "Technologie de filtration membranaire sélective qui sépare les molécules dissoutes et les ions multivalents tout en laissant passer les ions monovalents.",
      howItWorks: [
        'La solution aliment est pressurisée à 5-40 bar',
        'La membrane de nanofiltration sépare sélectivement les molécules',
        'Les ions multivalents et molécules organiques sont retenus',
        'Les ions monovalents passent partiellement',
        'Les flux de perméat et de concentrat sont collectés',
      ],
      appWaterSoftening: 'Adoucissement de Eau',
      appWaterSofteningDesc: "Élimination de la dureté et des sulfates",
      appColorRemoval: "Élimination des Couleurs",
      appColorRemovalDesc: 'Applications industrie textile et teinture',
      appPharmaceutical: 'Pharmaceutique',
      appPharmaceuticalDesc: 'Purification et concentration API',
      appEnvironmental: 'Environnemental',
      appEnvironmentalDesc: "Élimination des métaux lourds",
      advantages: [
        'Séparation ionique sélective',
        'Pression de fonctionnement inférieure à RO',
        'Consommation énergétique réduite',
        'Déminéralisation partielle',
        "Élimination des composés organiques",
        'Opération rentable',
      ],
    },
    ultrafiltration: {
      name: 'Ultrafiltration',
      description: "Processus de séparation par membrane qui élimine les macromolécules, colloïdes, bactéries et particules en suspension des solutions en utilisant des membranes poreuses.",
      howItWorks: [
        'La solution aliment circule à travers les modules membranaires',
        'Le différentiel de pression entraîne la séparation (1-10 bar)',
        'Les macromolécules et particules sont retenues',
        "L'eau et les solides dissous passent à travers",
        'Le retrolavage maintient la performance membranaire',
      ],
      appFoodProcessing: 'Transformation Alimentaire',
      appFoodProcessingDesc: 'Concentration et clarification des protéines',
      appBiotechnology: 'Biotechnologie',
      appBiotechnologyDesc: "Récolte cellulaire et récupération des protéines",
      appWaterTreatment: 'Traitement de Eau',
      appWaterTreatmentDesc: "Eau potable et traitement des eaux usées",
      appDairyIndustry: 'Industrie Laitière',
      appDairyIndustryDesc: "Traitement du lait et du lactosérum",
      advantages: [
        "Élimine les bactéries et virus",
        'Faible pression de fonctionnement',
        'Hauts taux de flux',
        'Utilisation minimale de produits chimiques',
        'Systèmes évolutifs',
        'Longue durée de vie membranaire',
      ],
    },
    microfiltration: {
      name: 'Microfiltration',
      description: "Filtration membranaire basse pression qui élimine les bactéries, solides en suspension et grosses particules pour des applications de clarification et de stérilisation.",
      howItWorks: [
        "L'aliment circule à travers les membranes microporeuses",
        'Faible différentiel de pression (0,1-3 bar) appliqué',
        'Les bactéries et particules sont retenues',
        'Le liquide clarifié passe à travers',
        'Modes de filtration tangentielle ou frontale',
      ],
      appBeverageClarification: 'Clarification des Boissons',
      appBeverageClarificationDesc: "Traitement de bière, vin et jus",
      appSterileFiltration: 'Filtration Stérile',
      appSterileFiltrationDesc: 'Applications pharmaceutique et biotech',
      appCellSeparation: 'Séparation Cellulaire',
      appCellSeparationDesc: 'Biotechnologie et recherche',
      appWaterTreatment: 'Traitement de Eau',
      appWaterTreatmentDesc: 'Prétraitement et polissage',
      advantages: [
        "Élimination efficace des bactéries",
        'Très faible pression de fonctionnement',
        'Hauts débits de traitement',
        'Capacité de stérilisation à froid',
        "Dégradation minimale du produit",
        "Opération et maintenance faciles",
      ],
    },
    coarseFiltration: {
      name: 'Filtration Grossière',
      description: "Processus de préfiltration qui élimine les grosses particules et solides en suspension pour protéger les équipements en aval et améliorer l'efficacité globale du processus.",
      howItWorks: [
        "L'aliment entre dans le boîtier filtre ou récipient",
        'Les grosses particules sont capturées par le média filtrant',
        'Le liquide clarifié circule à travers',
        'Le retrolavage élimine les solides accumulés',
        "Modes d'opération continue ou batch",
      ],
      appPretreatment: 'Prétraitement',
      appPretreatmentDesc: 'Protection des systèmes de filtration fine et média',
      appSedimentRemoval: "Élimination des Sédiments",
      appSedimentRemovalDesc: "Eau brute et flux de processus",
      appEquipmentProtection: 'Protection des Équipements',
      appEquipmentProtectionDesc: 'Pompes, vannes et instruments',
      appProcessWater: 'Eau de Processus',
      appProcessWaterDesc: "Conditionnement de l'eau industrielle",
      advantages: [
        'Faible coût de capital',
        "Opération simple",
        'Haute capacité de rétention de saletés',
        'Protège les équipements en aval',
        'Réduit les coûts de maintenance',
        "Prolonge la durée de vie des filtres fins",
      ],
    },
    filtrationMedia: {
      name: 'Média Filtrant',
      description: "Média filtrant métallique avancé et polymère composite conçu pour des applications spécifiques, offrant des performances et une durabilité supérieures.",
      howItWorks: [
        'Média sélectionné selon les besoins de application',
        'Particules capturées par filtration en profondeur ou en surface',
        'Structure du média optimisée pour le débit et la rétention',
        'Options nettoyables ou jetables disponibles',
        'Formulations de média personnalisées pour besoins spécifiques',
      ],
      appOilGas: 'Pétrole & Gaz',
      appOilGasDesc: 'Filtration et séparation de processus',
      appChemicalProcessing: 'Industrie Chimique',
      appChemicalProcessingDesc: 'Récupération de catalyseur et filtration produit',
      appFoodIndustry: 'Industrie Alimentaire',
      appFoodIndustryDesc: 'Clarification et stérilisation',
      appIndustrial: 'Industriel',
      appIndustrialDesc: 'Filtration de processus générale',
      advantages: [
        'Large gamme de matériaux',
        'Résistance aux hautes températures',
        'Compatibilité chimique',
        'Options réutilisables disponibles',
        'Propriétés personnalisables',
        'Longue durée de service',
      ],
      specs: {
        materials: 'Matériaux',
        poreSizes: 'Tailles de Pores',
        tempRange: "Plage de Température",
        chemicalResistance: 'Résistance Chimique',
      },
    },
  },
  cta: {
    title: 'Besoin d\'Aide pour Choisir la Bonne Technologie ?',
    subtitle: 'Nos experts techniques peuvent vous aider à choisir la solution de filtration optimale pour votre application spécifique',
    requestConsultation: 'Demander une Consultation Technique',
  },
};